import Carousel, { ModalGateway, Modal, CarouselState } from 'react-images'
interface Props {
  images: {
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }
  onClose: () => void // 关闭弹窗
}
const Previewimg = (props: Props) => {
  const { images, onClose } = props
  return (
    <ModalGateway>
      {images.data.length > 0 ? (
        <Modal onClose={onClose}>
          <Carousel
            currentIndex={images.currentIndex}
            styles={{
              header: () => ({
                position: 'absolute',
                top: 50,
                right: 50,
                zIndex: 1000,
              }),
              view: (a, b: CarouselState) => ({
                textAlign: 'center',
                height: b.isFullscreen ? '100%' : 600,
              }),
            }}
            views={images.data.map((item) => ({
              source: item,
              fullscreen: false,
            }))}
          />
        </Modal>
      ) : null}
    </ModalGateway>
  )
}
export default Previewimg
import Carousel, { ModalGateway, Modal, CarouselState } from 'react-images'
interface Props {
  images: {
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }
  onClose: () => void // 关闭弹窗
}
const Previewimg = (props: Props) => {
  const { images, onClose } = props
  return (
    <ModalGateway>
      {images.data.length > 0 ? (
        <Modal onClose={onClose}>
          <Carousel
            currentIndex={images.currentIndex}
            styles={{
              header: () => ({
                position: 'absolute',
                top: 50,
                right: 50,
                zIndex: 1000,
              }),
              view: (a, b: CarouselState) => ({
                textAlign: 'center',
                height: b.isFullscreen ? '100%' : 600,
              }),
            }}
            views={images.data.map((item) => ({
              source: item,
              fullscreen: false,
            }))}
          />
        </Modal>
      ) : null}
    </ModalGateway>
  )
}
export default Previewimg
